import React from 'react';
import classNames from 'classnames';
import injectIntl, { intlShape } from 'common/injectIntl';
import { trackSearch } from 'lib/omniture';

const DEFAULT_CONFIGURATION = {
    serviceUrl: 'http://espn.go.com',
    paths: {
        search: '/search/results'
    },
    queryParams: {
        edition: 'edition=watchespn'
    }
};

export class SearchContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.handleSearchTermEvent = this.handleSearchTermEvent.bind(this);
        this.state = {
            dirty: false,
            searchTerm: ''
        };
    }

    handleSearchSubmit(event) {
        event.preventDefault();
        trackSearch({ fromHero: this.props.isHero, searchTerm: this.state.searchTerm });
        const baseUrl = `${DEFAULT_CONFIGURATION.serviceUrl}${DEFAULT_CONFIGURATION.paths.search}`;
        window.location.href = `${baseUrl}?q=${encodeURI(this.state.searchTerm)}&${DEFAULT_CONFIGURATION.queryParams.edition}`;
    }

    handleSearchTermEvent(event) {
        this.setState({ searchTerm: event.target.value });
    }

    render() {
        const { enabled, messages, intl: { formatMessage } } = this.props;
        const searchClasses = classNames('search-section', 'icon-font-before', 'icon-search-solid-before', {
            'search-section--hero': this.props.isHero
        });
        return enabled ? (
            <section className={searchClasses}>
                <form onSubmit={this.handleSearchSubmit} >
                    <input
                        type="text"
                        placeholder={formatMessage(messages['search.placeholder'])}
                        name="search-section"
                        onChange={this.handleSearchTermEvent}
                    />
                </form>
            </section>
        ) : null;
    }
}

SearchContainer.propTypes = {
    enabled: React.PropTypes.bool,
    isHero: React.PropTypes.bool,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

SearchContainer.defaultProps = {
    enabled: false
};

export default injectIntl(SearchContainer);



// WEBPACK FOOTER //
// ./app/search/SearchContainer.js